// extracted by mini-css-extract-plugin
export default {"container":"fourth-screen_container__FDxu+"};